import Ticket from '../model';
import ModelFactory from '../../model-factory';

export default class Incident extends Ticket {
  constructor(data = {}) {
    super(data);
  }
}

export const modelFactory = new ModelFactory('in', (data) => new Incident(data));
